// app meta data, mainly used for wallet connect and html metadata
export const APP_TITLE = process.env.APP_TITLE ?? "clubs.frenfren.pro";
export const APP_DESCRIPTION = process.env.APP_DESCRIPTION ?? "";
export const APP_ICONS = (process.env.APP_ICONS ?? "").split(',');
export const GQL_ENDPOINT = process.env.GQL_ENDPOINT ?? "https://frenfren.pro/subgraphs/name/ft/clubs"
